import React from 'react';
import LiteGuideDoc from '../../assets/Hire-Intelligence-Lite-User-Guide.pdf';
const LiteGuide = () => {
	return (
		<div className="h-screen w-full overflow-hidden">
			<iframe
				title="Hire Intelligence Lite User Guide"
				src={LiteGuideDoc}
				className="h-full w-full border-0"
			/>
		</div>
	);
};
export default LiteGuide;
